<mat-table #table [dataSource]="dataSource" matSort matSortActive="created_at" matSortDirection="desc"
    matSortDisableClear [@animateStagger]="{value:'50'}">

    <!-- Notification Column -->
    <ng-container matColumnDef="notification">
        <mat-header-cell *matHeaderCellDef>{{'Message' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let notification">
            <p [ngClass]="{'font-weight-600' : !notification.data.read_at}">
                {{notification.data.message | translate}}{{notification.data.message2 |
                translate}}{{notification.data.message3 | translate}}{{notification.data.message4 | translate}}</p>
        </mat-cell>
    </ng-container>

    <!-- Date Column -->
    <ng-container matColumnDef="created_at">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Date' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let notification">
            <p class="text-truncate" [ngClass]="{'font-weight-600' : !notification.read_at}">
                {{notification.created_at}}</p>
        </mat-cell>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="read_at">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Status' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let notification">
            <p class="text-truncate red" *ngIf="!notification.read_at">{{'New' | translate}}</p>
            <p class="text-truncate" *ngIf="notification.read_at">{{'Seen' | translate}}</p>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let notification; columns: displayedColumns;" [ngClass]="{'deleted': notification.read_at}"
        matRipple [@animate]="{value:'*',params:{y:'100%'}}" (click)="markAsRead(notification)">
    </mat-row>
</mat-table>
<mat-paginator #paginator [length]="totalElements" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25]"
    [hidePageSize]="true" [fxHide]="totalElements === 0">
</mat-paginator>